<script setup>
import { WButton, WParagraph, WTag, WTitle } from '@alice-health/wonderland-vue'
import { inject } from 'vue'

const notify = inject('notify')

const props = defineProps({
  memberInfos: {
    type: Object,
    default: () => ({})
  },
  channelId: {
    type: String,
    required: true
  }
})

const copy = async text => {
  try {
    await window.navigator.clipboard.writeText(text)
  } catch (error) {
    notify({
      description: `Erro ao copiar ${text}.`,
      duration: 2000
    })
  }
}

const getValueMaxLength = value => {
  const maxLength = 18
  if (!value) return '-'
  const length = Math.min(value.length, maxLength)
  const showEllipsis = length !== value.length
  return showEllipsis ? `${value.substring(0, length)}...` : value
}
</script>
<template>
  <div class="member_card">
    <div class="header_details">
      <WTitle size="xsmall" variant="heavy">{{
        getValueMaxLength(props.memberInfos.fullName)
      }}</WTitle>
      <WTag
        v-if="props.memberInfos.product"
        color="blue"
        :label="`${props.memberInfos.product.product.type} - ${props.memberInfos.product.product.displayName}`"
        size="large"
      />
    </div>
    <div class="body_details">
      <div>
        <WParagraph class="body_title" variant="heavy">ID do canal</WParagraph>
        <WButton
          variant="tertiary"
          size="small"
          icon="icCopy"
          icon-position="trailing"
          @click="copy(props.channelId)"
        >
          {{ props.channelId }}</WButton
        >
      </div>

      <div>
        <WParagraph class="body_title" variant="heavy"
          >Código interno</WParagraph
        >
        <WButton
          variant="tertiary"
          size="medium"
          icon="icCopy"
          icon-position="trailing"
          @click="copy(props.memberInfos.internalCode)"
          >{{ props.memberInfos.internalCode }}</WButton
        >
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.header_details {
  display: flex;
  align-items: center;
  padding-left: var(--gl-spacing-08);
  padding-top: var(--gl-spacing-04);
  padding-bottom: var(--gl-spacing-04);
  gap: var(--gl-spacing-02);
  background: var(--gl-color-shades-gray-00);
}
.body_details {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  vertical-align: middle;
  padding-left: var(--gl-spacing-04);
  padding-top: var(--gl-spacing-02);
  padding-bottom: var(--gl-spacing-02);
}
.body_title {
  padding-left: var(--gl-spacing-04);
}
.member_card {
  border: var(--gl-border-width-xs) solid var(--gl-color-shades-gray-20);
  border-radius: var(--gl-spacing-04);
  overflow-y: auto;
  padding: 0px;
}
</style>
